import SEO from '../components/SEO/SEO'
import Layout from '../layout/Layout'
import Link from 'next/link'

const Careers = () => {
  return (
    <>
      <SEO />
      <Layout>
        <div className="relative">
          <div className="absolute inset-x-0 bottom-0 bg-gray-100 h-1/2" />
          <div className="mx-auto">
            <div className="relative">
              <div className="absolute inset-0">
                <img
                  className="object-cover w-full h-full"
                  src="banner/about-banner.png"
                  alt="Evry Health careers and team culture"
                />
              </div>
              <div className="relative max-w-screen-xl px-4 py-16 mx-auto md:py-16 lg:py-32">
                <h1
                  className="text-3xl leading-8 tracking-tight md:text-5xl text-darkBlue"
                  style={{ lineHeight: 1.15 }}
                >
                  We&#39;re making health insurance <br />
                  work again.{' '}
                  <span className="leading-8 text-globeGreen">Join us.</span>
                </h1>
                <a
                  href="https://jobs.lever.co/evry-health"
                  target="_blank"
                  rel="noreferrer"
                >
                  <button className="inline-block px-8 py-2 mt-8 text-xl font-bold bg-transparent border-2 text-blue border-blue hover:bg-blue hover:text-white-light">
                    Apply Now
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>

        <section>
          <div className="max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8">
            <div className="grid gap-16 lg:grid-cols-2 lg:items-center">
              <div className="mb-8 lg:col-span-1 md:mb-0">
                <h2 className="pb-8 text-4xl tracking-tight font-extralight text-darkBlue">
                  Careers at Evry
                </h2>
                <div className="text-base text-grey">
                  <p className="inline-block pb-4 md:pr-20">
                    We&#39;re seeking people who are the very best at what they
                    do. Opportunities at Evry run deep and when you work with
                    people you enjoy spending time with, on a worthwhile
                    mission, the days are great.
                  </p>
                  <p className="pb-4">
                    We offer competitive compensation and a full benefits
                    package including health insurance, 401(k) matching, and
                    flexible vacation.
                  </p>
                  <p className="pb-6">
                    Evry is currently hiring across a range of departments for
                    both senior and junior level positions. Roles include:
                  </p>

                  <ul className="ml-8 list-disc">
                    <li>Claims administration</li>
                    <li>Customer service</li>
                    <li>Care management</li>
                    <li>Full stack back-end development</li>
                    <li>Front-end development</li>
                    <li>Quality assurance testing</li>
                    <li className="pb-6">And more!</li>
                  </ul>

                  <p>
                    Even if none of the above apply to you, if you have years of
                    professional experience, are talented at what you do, and
                    possess a skillset you think would help us, contact us to
                    learn more about current opportunities.
                  </p>
                </div>
                <a
                  href="mailto:jobs@evryhealth.com"
                  className="px-8 py-2 bg-transparent text-blue border-2 border-blue hover:bg-blue hover:text-white-light inline-block mt-8 text-xl font-bold font-[sans-serif]"
                >
                  Send us your resume
                </a>
                <p className="pt-5 text-grey">
                  And follow us on{' '}
                  <a
                    className="text-blue hover:underline"
                    href="https://www.linkedin.com/company/evryhealth/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    LinkedIn
                  </a>
                  .
                </p>
              </div>
              <div className="lg:col-span-1">
                <div className="flex items-center justify-center h-full">
                  <img
                    src="group-headshots.png"
                    className="img-fluid"
                    alt="Evry Health team headshots"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-gray-100">
          <div className="max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8">
            <h2 className="pb-8 text-4xl tracking-tight font-extralight text-darkBlue text-center">
              Open Positions
            </h2>
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <iframe
                src="https://jobs.lever.co/evry-health"
                width="100%"
                height="800"
                style={{ border: 'none', display: 'block' }}
                title="Evry Health Job Openings"
              />
            </div>
          </div>
        </section>
      </Layout>
    </>
  )
}

export default Careers
